import cookiesStorage, {
  createCookie,
  readCookie,
  eraseCookie,
} from "./cookies";
import {
  searchQuerySeparator,
  requiredKeysForListing,
  facebook,
  APP_BREAKPOINTS,
  subPromoSeparator,
  STORAGE_KEYS,
  BACKGROUND_COLOR_SET,
  PINCODE_LENGTH,
} from "../constants";
import arrayToKeyValuePair from "./normalization";
import somethingWentWrong from "./toastrs";
import { Utils } from "arv-reactcomponents";

// const basePathUrl = process.env.REACT_APP_BASE_PATH_URL;

const noResults = () => {
  window.location.href = `${window.location.origin}/noresults${
    window.location.search
  }`;
};
const objToQueryParams = paramsObj =>
  Object.keys(paramsObj)
    .map(
      key => `${encodeURIComponent(key)}=${encodeURIComponent(paramsObj[key])}`,
    )
    .join("&");

const queryParamsToObject = search => {
  const hashes =
    (search && search.slice(search.indexOf("?") + 1).split("&")) || [];
  const params = {};
  hashes.map(hash => {
    const [key, val] = hash.split("=");
    params[key] = decodeURIComponent(val);
    return null;
  });
  return params;
};

const getlastUsedPincode = () => {
  try {
    window.localStorage.removeItem("last-used-pincode"); // to be removed after sometime
    let pincodeArray = window.localStorage.getItem(
      STORAGE_KEYS.LAST_USED_PINCODE,
    );
    if (!pincodeArray) {
      pincodeArray = JSON.stringify({ list: [] });
    }
    pincodeArray = JSON.parse(pincodeArray);
    return (
      (pincodeArray &&
        pincodeArray.list &&
        pincodeArray.list[0] &&
        pincodeArray.list[0].pincode) ||
      ""
    );
  } catch (err) {
    // catch error if no getItem on localStorage
    console.log("RECENTLY USED PINCODE OPERATION FAILED");
    window.localStorage.removeItem(STORAGE_KEYS.LAST_USED_PINCODE);
    return "";
  }
};

const setLastUsedPincode = pincode => {
  try {
    window.localStorage.removeItem("last-used-pincode"); // to be removed after sometime
    let pincodeArray = window.localStorage.getItem(
      STORAGE_KEYS.LAST_USED_PINCODE,
    );
    if (!pincodeArray) {
      pincodeArray = JSON.stringify({ list: [] });
    }
    pincodeArray = JSON.parse(pincodeArray);
    pincodeArray.list = pincodeArray.list.filter(
      item => item.pincode !== pincode,
    );
    const d = new Date();
    const lastModifiedDate = `${[
      d.getFullYear(),
      d.getMonth() + 1,
      d.getDate(),
    ].join("-")} ${[d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds()].join(
      ":",
    )}`;
    pincodeArray.list.unshift({ pincode, lastModifiedDate });
    window.localStorage.setItem(
      STORAGE_KEYS.LAST_USED_PINCODE,
      JSON.stringify(pincodeArray),
    );
  } catch (err) {
    window.localStorage.removeItem(STORAGE_KEYS.LAST_USED_PINCODE);
  }
};

const getHref = href => {
  if (!href || !href.replace("s", "g")) {
    // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
  }
  if (/^(http:\/\/|https:\/\/|\/\/|\/)/.test(href)) {
    return href;
  }
  return `//${href}`;
};

const redirect = path => {
  window.location.href = `${window.location.origin}/${path}`;
};
const getAuthenticationToken = token => {
  try {
    const accessToken = readCookie(token);
    return accessToken || null;
  } catch (exception) {
    return null;
  }
};

const isEmptyObject = obj =>
  Object.keys(obj).length === 0 && obj.constructor === Object;

const validateEmail = email => {
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (re.test(email)) {
    return true;
  }
  return false;
};

// const globalConfigVar =
//   (window && window.GL) ||
//   (global && global.globalConfig && global.globalConfig.isDesktop);
// console.log(
//   "globalConfigglobalConfigglobalConfigglobalConfigglobalConfigglobalConfig",
//   globalConfigVar,
// );
// const isDesktop = () => globalConfig && globalConfig.isDesktop;
const isLandscape = (() => {
  const { screen, innerWidth } = window || {};
  const { orientation } = screen || {};
  const { type = "" } = orientation || {};
  const orientationFromVal = type.indexOf("landscape") > -1;
  const orientationFromWidth = innerWidth > APP_BREAKPOINTS.XS;
  return orientationFromVal || orientationFromWidth;
})();
const isApp = !!readCookie("app") || false;
const isDesktop = (windowWidth => {
  const globalConfigVar =
    (window && window.GL) ||
    (global && global.globalConfig && global.globalConfig);

  if (globalConfigVar) {
    return globalConfigVar.isDesktop;
  }
  return windowWidth || window.innerWidth > APP_BREAKPOINTS.XS;
})();

const jumpToTopHideHeader = () => {
  window.scrollTo(0, 100);
};

const getPagePath = () => {
  // const path = window.location.pathname;
  const brand = "Arrow";
  return brand;
};

const getBrandName = () => {
  const brandName = getPagePath();
  return brandName;
};

const isBrandPage = () => {
  const brand = getPagePath();
  return !!brand;
};

const sortArrayOfStrings = array => {
  const sortedArray = array.sort((a, b) => {
    if (a.toLowerCase() < b.toLowerCase()) return -1;
    if (a.toLowerCase() > b.toLowerCase()) return 1;
    return 0;
  });

  return sortedArray;
};

const ifElementInParentView = (parent, el) => {
  const elem = el;
  const elTop = elem.offsetTop;
  const elBottom = elTop + elem.offsetHeight;

  const pTop = parent.offsetTop;
  const pBottom = pTop + parent.offsetHeight;

  return elBottom >= pTop && elTop <= pBottom;
};

const getFilterUrl = (filterby, mapping, incomingSearch) => {
  const search = incomingSearch.replace(/\+/g, "%20");
  const urlObject = queryParamsToObject(search);
  switch (mapping) {
    case "na":
    case "os":
      if (urlObject[mapping]) {
        delete urlObject[mapping];
      } else {
        urlObject[mapping] = true;
      }
      break;
    case "p-dl":
    case "p-st":
    case "sort":
    case "r":
      urlObject[mapping] = filterby.value;
      break;
    case "f-pro":
      if (!urlObject[mapping]) {
        urlObject[mapping] = filterby.value;
      } else {
        const urlArray = urlObject[mapping].split(searchQuerySeparator);
        const requestPromotionArray = filterby.value.split(subPromoSeparator);
        const requestBasePromotion = requestPromotionArray[0];
        requestPromotionArray.splice(0, 1);
        const requestSubPromotion = requestPromotionArray;
        const indexAtUrlArray = urlArray.findIndex(
          item => item.indexOf(requestBasePromotion) > -1,
        );
        const filterAtUrl = urlArray[indexAtUrlArray];
        if (indexAtUrlArray === -1) {
          urlArray.push(filterby.value);
        } else if (requestSubPromotion.length === 0) {
          urlArray.splice(indexAtUrlArray, 1);
        } else if (filterAtUrl === filterby.value) {
          urlArray.splice(indexAtUrlArray, 1);
          urlArray.push(requestBasePromotion);
        } else {
          urlArray[indexAtUrlArray] = filterby.value;
        }

        urlObject[mapping] = urlArray.join(searchQuerySeparator);
        if (!urlArray.length) {
          delete urlObject[mapping];
        }
      }
      break;
    default:
      if (!urlObject[mapping]) {
        urlObject[mapping] = filterby.value;
      } else {
        const urlArray = urlObject[mapping].split(searchQuerySeparator);
        const index = urlArray.indexOf(filterby.value);
        if (index > -1) {
          urlArray.splice(index, 1);
        } else {
          urlArray.push(filterby.value);
        }
        urlObject[mapping] = urlArray.join(searchQuerySeparator);
        if (!urlArray.length) {
          delete urlObject[mapping];
        }
      }
      break;
  }
  return objToQueryParams(urlObject);
};
const appendCprToUrl = (url, data) => {
  const urlObj = queryParamsToObject(url);
  if (!urlObj["f-pr"]) {
    delete urlObj.cpr;
    return objToQueryParams(urlObj);
  }
  const priceFilter =
    data &&
    data.filters &&
    data.filters.filterBy &&
    data.filters.filterBy.find(filter => filter.filterType === "Price");
  const cpr =
    (priceFilter &&
      priceFilter.list &&
      priceFilter.list
        .map(filter => filter.value)
        .join(searchQuerySeparator)) ||
    null;
  urlObj.cpr = cpr;
  return objToQueryParams(urlObj);
};

const isStringInArray = (string, array) => {
  const selection = array.find(
    item => string.toLowerCase() === item.toLowerCase(),
  );
  return selection;
};

const setPageType = sourcePage => {
  window.pageType = sourcePage;
};
const isFilterSelected = (filter, mapping, searchString) => {
  const queryObj = queryParamsToObject(searchString);
  const filterAtUrl = queryObj[mapping] || "";
  return (
    filterAtUrl
      .split(searchQuerySeparator)
      .filter(item => item === filter.value).length > 0
  );
};

const isAuthenticated = () => {
  const accessToken = readCookie("accessToken");
  const refreshToken = readCookie("refreshToken");
  return !!accessToken && !!refreshToken;
};

const validatePincode = input => {
  let errorMsg = "";
  if (input.length === 0) {
    errorMsg = "Please enter pincode";
  } else if (!/^\d+$/.test(input)) {
    errorMsg = "Please enter only digits";
  } else if (input.length !== PINCODE_LENGTH) {
    errorMsg = `Please enter ${PINCODE_LENGTH} Digits`;
  }
  return errorMsg;
};

const getClientUniqueId = () => {
  if (process.env.NODE_ENV === "test") {
    return Date.now() + Math.round(Math.random() * 10 ** 10);
  }
  if (!global || !global.isServer) {
    const clientUniqueId = window.sessionStorage.getItem("client_unique_id");
    if (!clientUniqueId) {
      const clientId = Date.now() + Math.round(Math.random() * 10 ** 10);
      window.sessionStorage.setItem("client_unique_id", clientId);
      return clientId;
    }
    return clientUniqueId;
  }
  return null;
};
const clearedUrl = (pathname, search) => {
  const searchObj = queryParamsToObject(search);
  const newObj = {};
  Object.entries(searchObj).forEach(([key, value]) => {
    if (requiredKeysForListing.includes(key)) {
      newObj[key] = value;
    }
  });

  const newSearch = objToQueryParams(newObj);
  return `${pathname}?${newSearch}`;
};
const imageSize = 24;

const processShippingDate = shippingDetails => {
  const modes = [];
  shippingDetails.forEach(value => {
    const item = {};
    if (value.toLowerCase().indexOf("standard") > -1) {
      item.order = 3;
      item.name = "Delivery within 5-7 days";
      modes.push(item);
    } else if (value.toLowerCase().indexOf("next day delivery") > -1) {
      item.order = 2;
      item.name = "Delivery Tomorrow";
      modes.push(item);
    } else if (value.toLowerCase().indexOf("same day delivery") > -1) {
      item.order = 1;
      item.name = "Delivery Today";
      modes.push(item);
    } else {
      item.order = 0;
      item.name = "Pickup from the nearest";
      item.popup =
        "Place the order now and collect your items from a nearby store. We will keep it ready for you";
      modes.push(item);
    }
  });
  modes.sort((a, b) => a.order - b.order);
  return modes;
};

const isWishList = styleId => {
  if (!styleId) {
    const wishlist = window.sessionStorage.getItem("wishList");
    // TODO enable array wishlist post ODIN2.0 pdp

    // wishlist = JSON.parse(wishlist);
    // if (wishlist && wishlist.length > 0) {
    //   const body = [];
    //   wishlist.forEach(style => {
    //     body.push({ styleId: style });
    //   });
    //   return JSON.stringify(body);
    // }
    if (wishlist) {
      return JSON.stringify([{ styleId: wishlist }]);
    }
    return null;
  }
  return JSON.stringify([{ styleId }]);
};

const fbLoad = () => {
  const { appId, version, scope, xfbml } = facebook;
  window.FB.init({
    appId,
    xfbml,
    version,
    scope,
  });
};
const fbInit = fbLoaded => {
  if (window.FB) {
    fbLoaded();
  }
  (function(d, s, id) {
    let js = d.getElementsByTagName(s)[0];
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.onload = () => {
      fbLoad();
      fbLoaded();
    };
    js.src = facebook.url;
    fjs.parentNode.insertBefore(js, fjs);
  })(document, "script", "facebook-all");
};
const authHeader = () => {
  const retObj = {
    authorization: `Bearer ${readCookie("accessToken")}`,
  };
  return retObj;
};
const sanitiseUrl = url =>
  url && url.indexOf(".com") > -1 && url.indexOf("http") === -1
    ? `https://${url}`
    : url;

const getCurrentHref = () =>
  (window && window.location && window.location.href) || Utils.noop;

const generateGaLabel = value => value.replace(/\s+/g, "_").toLowerCase();
const isPdpPage = url => {
  const regex = new RegExp("^/?((?:[\\w\\d]+-+)){2,}[A-Z\\d]{10,11}$");
  return regex.test(url);
};
const deduceValuesFromPipedData = (pcmData = "") => {
  const splitArray = (pcmData && pcmData.split("||")) || [];
  let type = "";
  let id = "";
  let url = "";
  let legalBrandNameString = "";
  let image = "";
  let sapBrand = "";
  let baseProduct = "";
  let baseProductId = "";
  const getTypeMetaData = pcmData.match(
    /.*(?:\|\|)(.*)(?:\|\|)(.*)(?:\|\|)(.*)$/,
  );
  const iterablegetTypeMetaData = getTypeMetaData ? [...getTypeMetaData] : [];
  const [, keywords, description, title] = iterablegetTypeMetaData;

  [type, id, url, legalBrandNameString] = splitArray;
  if (type === "Style") {
    [
      type,
      id,
      url,
      image,
      sapBrand,
      legalBrandNameString,
      baseProduct,
      baseProductId,
    ] = splitArray;
  }
  return {
    type,
    id,
    url: sanitiseUrl(url),
    legalBrandNames:
      (legalBrandNameString && legalBrandNameString.split(",")) || [],
    keywords,
    description,
    title,
    image,
    sapBrand,
    baseProduct,
    baseProductId,
  };
};
function* loopArrayValues(setArray) {
  for (let i = 0; i <= setArray.length + 1; i += 1) {
    i = (i < setArray.length && i) || 0;
    yield setArray[i];
  }
}
const colorIterator = loopArrayValues(BACKGROUND_COLOR_SET);
const getBackgroundColorCode = () => colorIterator.next().value;

const getBrandsListFromFiltersAPI = response => {
  // const brandObject = response.filter(obj => obj.filterType === "Brand");
  const brandsList = response.map(brand => brand.parentBrand);
  return brandsList;
};
const getBaseRouteForPath = url =>
  (url && url.split("/").filter(item => item)[0]) || "";

const checkIfBrandJourney = hostname =>
  !/^(www|smpreprod|preprod|odin-qa\d?|sm\d?|shakthiman-qa\d?|mumbai-prod)\.(ailiens|nnnow)\.com/.test(
    hostname,
  );
export {
  checkIfBrandJourney,
  getBaseRouteForPath,
  isApp,
  getBackgroundColorCode,
  deduceValuesFromPipedData,
  isPdpPage,
  sanitiseUrl,
  authHeader,
  fbInit,
  clearedUrl,
  somethingWentWrong,
  isFilterSelected,
  setPageType,
  noResults,
  objToQueryParams,
  getlastUsedPincode,
  setLastUsedPincode,
  getHref,
  createCookie,
  readCookie,
  eraseCookie,
  cookiesStorage,
  getAuthenticationToken,
  redirect,
  validateEmail,
  isEmptyObject,
  isLandscape,
  isDesktop,
  jumpToTopHideHeader,
  getBrandName,
  isBrandPage,
  sortArrayOfStrings,
  ifElementInParentView,
  queryParamsToObject,
  getFilterUrl,
  appendCprToUrl,
  isStringInArray,
  isAuthenticated,
  arrayToKeyValuePair,
  validatePincode,
  getClientUniqueId,
  imageSize,
  processShippingDate,
  isWishList,
  getCurrentHref,
  generateGaLabel,
  getBrandsListFromFiltersAPI,
};



// WEBPACK FOOTER //
// ./src/utils/index.js